import React from 'react';
import AboutUS from '../../components/aboutUs';

const AboutUsPage = () => {
  return (
    <>
      <AboutUS />
    </>
  );
};

export default AboutUsPage;
